
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RequiredFieldLabel } from "@/components/ui/required-field-label";

interface DateRangeInputsProps {
  form: UseFormReturn<any>;
  startDateName: string;
  endDateName: string;
  startDateLabel?: string;
  endDateLabel?: string;
  startInputValue: string;
  endInputValue: string;
  handleStartDateInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEndDateInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleStartDateBlur: () => void;
  handleEndDateBlur: () => void;
  disabled?: boolean;
}

export const DateRangeInputs: React.FC<DateRangeInputsProps> = ({
  form,
  startDateName,
  endDateName,
  startDateLabel = "Start date",
  endDateLabel = "End date",
  startInputValue,
  endInputValue,
  handleStartDateInputChange,
  handleEndDateInputChange,
  handleStartDateBlur,
  handleEndDateBlur,
  disabled = false
}) => {
  const startError = form.formState.errors[startDateName];
  const endError = form.formState.errors[endDateName];
  
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <FormField
        control={form.control}
        name={startDateName}
        render={() => (
          <FormItem>
            <FormLabel>
              <RequiredFieldLabel label={startDateLabel} />
            </FormLabel>
            <FormControl>
              <Input
                placeholder="MM/DD/YYYY"
                value={startInputValue}
                onChange={handleStartDateInputChange}
                onBlur={handleStartDateBlur}
                disabled={disabled}
                className="w-full"
              />
            </FormControl>
            {startError && <FormMessage>{startError.message as string}</FormMessage>}
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name={endDateName}
        render={() => (
          <FormItem>
            <FormLabel>
              <RequiredFieldLabel label={endDateLabel} />
            </FormLabel>
            <FormControl>
              <Input
                placeholder="MM/DD/YYYY"
                value={endInputValue}
                onChange={handleEndDateInputChange}
                onBlur={handleEndDateBlur}
                disabled={disabled}
                className="w-full"
              />
            </FormControl>
            {endError && <FormMessage>{endError.message as string}</FormMessage>}
          </FormItem>
        )}
      />
    </div>
  );
};
